import { render, staticRenderFns } from "./VipList.vue?vue&type=template&id=56b218f8&scoped=true"
import script from "./VipList.vue?vue&type=script&lang=ts"
export * from "./VipList.vue?vue&type=script&lang=ts"
import style0 from "./VipList.vue?vue&type=style&index=0&id=56b218f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b218f8",
  null
  
)

export default component.exports